// Name of /foto-bibliothek (Mike 2026-10-10): hotels see "Post-Bibliothek", agencies keep "Foto-Bibliothek".
// The route stays /foto-bibliothek so no link breaks.
export const HOTEL_LIBRARY_NAME = "Post-Bibliothek";
export const AGENCY_LIBRARY_NAME = "Foto-Bibliothek";

export function libraryName(hotel: boolean): string {
  return hotel ? HOTEL_LIBRARY_NAME : AGENCY_LIBRARY_NAME;
}
